<template>
  <div class="code">
    <div class="url-input clearfix">
      <div class="input-left">
        <el-input v-model="url" type="textarea" :rows="27" placeholder="转换的内容粘贴在这里" />
      </div>
      <div class="input-right">
        <h5>encodeURI编码,不会对特殊符号编码</h5>
        <el-input v-model="encodeURIcontent" type="textarea" :rows="10" placeholder="encodeURI结果" />
        <h5>encodeURIComponent编码方式，会对特殊符号编码</h5>
        <el-input v-model="encodeURIComponentContent" type="textarea" :rows="10" placeholder="encodeURIComponent结果" />
        <div class="url-btn">
          <!--<el-select v-model="charset" showArrow placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>-->

          <el-button type="primary" @click="codeUrl">URL编码</el-button>
          <el-button type="primary" @click="decodeUrl">URL解码</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      encodeURIcontent: '',
      encodeURIComponentContent: '',
      url: '',

      options: [
        {
          value: 'utf8',
          label: 'UTF-8'
        },
        {
          value: 'gb2312',
          label: 'GB2312'
        }
      ],
      charset: "utf8"
    }
  },
  methods: {

    codeUrl () {
      if (this.url == '') return
      this.encodeURIcontent = encodeURI(this.url)
      this.encodeURIComponentContent = encodeURIComponent(this.url)
    },
    decodeUrl () {
      if (this.url == '') return
      this.encodeURIcontent = decodeURI(this.url)
      this.encodeURIComponentContent = decodeURIComponent(this.url)
    }
  }
}
</script>

<style lang="stylus" scope>
.code
  .code-input
    .el-textarea
      width 590px
    .el-textarea:last-child
      float right
  .code-btn
    margin-top 22px
  .url-btn
    margin-top 22px
    margin-bottom 10px
    .el-select
      width 140px
      margin-right 10px
  h5
    margin-bottom 10px

  .url-input
    h5
      margin-top 10px
      margin-bottom 10px
    .input-left
      float left
      width 590px
    .input-right
      float right
      width 590px

</style>
